import React from "react";
import { Link } from "react-router-dom";
import { Flex, Tag, theme } from "antd";
import ResponsiveTable from "../../../../../design-system/ResponsiveTable";
import defaultImage from "../../../../../commons/PanelAssets/img/doctors/doctor-01.jpg";
import Tagcomp from "../../../../../commons/TagComp/Tagcomp";
import ContractList from "../../../contracts/ContractList";

import { useTranslation } from "react-i18next";
const EmployeeContracts = ({ employeeObject }) => {
  const { t } = useTranslation("dashboard");
  const { token } = theme.useToken();
  const columns = [
    {
      title: t("Name"),
      dataIndex: "name",
      render: (text, record) => (
        <>
          <Link
            to={`/user/user-profile/${record?._id}`}
            style={{ display: "inline-flex", alignItems: "center", gap: token.marginSM }}
          >
            <img
              alt=""
              style={{ objectFit: "cover" }}
              width="50"
              height="50"
              className="rounded-circle"
              src={record?.picture ? record?.picture?.url : defaultImage}
            />
            <span style={{ color: token.colorText, overflowWrap: "anywhere" }}>
              {record?.firstName} {record?.lastName}
            </span>
          </Link>
        </>
      ),
      sorter: (a, b) => a.firstName.localeCompare(b.firstName)
    },
    {
      title: t("Department"),
      key: "department",
      mobile: "subtitle",
      render: (text, record) => <div>{record?.department?.title}</div>
    },
    {
      title: t("Job Title"),
      key: "designation",
      render: (text, record) => <div>{record?.designation?.title}</div>
    },
    {
      title: t("Email"),
      dataIndex: "email",
      sorter: (a, b) => a.email.localeCompare(b.email)
    },
    {
      title: t("Start Date"),
      dataIndex: "startDate",
      render: (text, record) => <div>{record?.startDate}</div>
    },
    {
      title: t("End Date"),
      dataIndex: "endDate",
      render: (text, record) => <div>{record?.endDate}</div>
    },
    {
      title: t("Hours/week"),
      dataIndex: "workSchedule",
      render: (text, record) => <div>{text}</div>
    },
    {
      title: t("Working Days"),
      dataIndex: "workingDays",
      render: (text, record) => (
        <Flex align={"center"} gap={2} wrap="wrap">
          {record?.workingDays &&
            record?.workingDays?.map(t => {
              return (
                <Tag style={{ marginInlineEnd: "0px" }} key={t}>
                  {t?.slice(0, 3)}
                </Tag>
              );
            })}
        </Flex>
      )
    },
    {
      title: t("Salary"),
      dataIndex: "salary",
      render: (text, record) => (
        <div>
          {record?.salary
            ? `${record.salary} / ${record?.workSchedule === "hourly" ? t("hour") : t("month")}`
            : null}
        </div>
      )
    },
    {
      title: t("Status"),
      dataIndex: "status",
      render: text => <Tagcomp text="Active" />
    }
  ];

  return (
    <div>
      <ResponsiveTable
        className="contentclass"
        dataSource={[employeeObject]}
        columns={columns}
        pagination={false}
        rowKey={record => record._id}
      />
      <h5 className="mt-4 mb-3">{t("Contract documents")}</h5>
      <ContractList employeeId={employeeObject?._id} />
    </div>
  );
};

export default EmployeeContracts;
